import { FlexAligner, IconButton, Severity } from '@scaleaq/scaleui';
import { background } from '@scaleaq/sui-tokens/colors';
import { styled } from 'styled-components';

import { Z_INDEX } from '@/constants/zIndex';

const alertWrapperBottom = '5rem';
export const LoadingWrapper = styled(FlexAligner)`
  position: absolute;
  inset: 0;
  z-index: ${Z_INDEX.overlay.loading};

  opacity: 0.8;
  background-color: ${background.neutral.soft[200]};
`;
export const AlertWrapper = styled(FlexAligner)<{ $speed: number }>`
  position: absolute;
  z-index: ${Z_INDEX.overlay.loading};
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  animation: alertAnimation;
  animation-duration: ${({ $speed }) => `${$speed}ms`};
  inset: auto 0 ${alertWrapperBottom};
  white-space: pre-line;
  overflow-wrap: anywhere;

  /*
   * A long unbroken token (a level id in an error) sets the flex min-content
   * width. The alert then centers that width and the modal clips both ends.
   * overflow-wrap: anywhere lets that token wrap and keeps the min-content
   * width inside the modal. The close button keeps its own min-width.
   */
  & > * {
    min-width: 0;
    max-width: 100%;
  }

  & > * > :first-child {
    flex: 1 1 auto;
    min-width: 0;
  }

  & p {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  @keyframes alertAnimation {
    0% {
      bottom: 0;
    }
    50%,
    100% {
      bottom: ${alertWrapperBottom};
    }
  }
`;
export const StyledIconButton = styled(IconButton)<{ $feedbackVariant: Severity }>`
  &:hover {
    background-color: ${({ $feedbackVariant }) => {
      switch ($feedbackVariant) {
        case 'info':
          return background.info.solid[200];
        case 'warning':
          return background.warning.solid[200];
        case 'alarm':
          return background.alarm.solid[100];
        case 'caution':
          return background.caution.solid[100];
        case 'critical':
          return background.critical.solid[100];
        default:
          return background.success.solid[200];
      }
    }};
  }
`;
